import { Button, JaneGoldIcon, Typography } from '@iheartjane/reefer';
import { useCallback } from 'react';

import { handleFilterChange } from '@jane/search/util';

import { useKioskSpacing } from '../../../hooks';
import { useSearchContext } from '../../../providers';

export const JaneGoldFilter = ({ disabled }: { disabled: boolean }) => {
  const { isIpad } = useKioskSpacing();
  const { searchState, setSearchState } = useSearchContext();
  const isSelected = searchState.filters?.has_brand_discount?.[0] === 'true';

  const onGoldSelected = useCallback(() => {
    return setSearchState(
      handleFilterChange('has_brand_discount', 'true', searchState)
    );
  }, [searchState, setSearchState]);
  return (
    <Button
      variant={isSelected ? 'primary' : 'tertiary'}
      label={
        <Typography
          variant="body-bold"
          color={isSelected ? 'grays-white' : 'grays-black'}
        >
          Jane Gold
        </Typography>
      }
      startIcon={<JaneGoldIcon color="gold" />}
      size={isIpad ? 'small' : 'default'}
      onClick={() => onGoldSelected()}
      disabled={disabled}
    />
  );
};
